// /web/src/pages/Blog.jsx

const publishedDate = "17 Novemeber, 2025";

export default function Blog() {
  return (
    <section className="pd-blog prose">
      <header className="pd-blog__header">
        <p className="small" style={{ textTransform: "uppercase", letterSpacing: 0.4 }}>
          {publishedDate}
        </p>
        <h1>Pebbledash launches</h1>
        <p className="lead" style={{ marginTop: 0 }}>
          A faster, clearer way to understand buildings before they are drawn.
        </p>
      </header>

      <article className="pd-blog__body">
        <p>
          Architecture has always balanced intuition with data. We draw, test, revise, and
          estimate, often on partial information. Pebbledash was built to close that gap; to
          bring clarity to the earliest design decisions, when the biggest impacts are made and
          the fewest facts are known.
        </p>

        <p>
          Pebbledash is a platform for architects, engineers, and developers to run quick,
          reliable studies before a project even begins. It calculates what a building can hold,
          how it moves, and how it performs. The current suite includes lift traffic analysis, WC
          provision, riser sizing, and U-values, all aligned with UK standards for office design.
          Every calculation runs instantly and traces back to clear rules, so designers can move
          forward with confidence.
        </p>

        <p>
          The goal is not to replace judgment, but to sharpen it. Pebbledash automates the
          repetitive parts of feasibility, the parts that slow down thinking, so that design teams
          can focus on design not metrics.
        </p>

        <h2>What comes next</h2>
        <p>Over the next phase, we’re expanding Pebbledash in three directions:</p>
        <ol>
          <li>
            <strong>Expand our tools:</strong> Extending the existing suite to include end-of-trip
            facilities, cycle spaces, showers, and plant area calculators, building a more complete
            picture of building services from the outset.
          </li>
          <li>
            <strong>New use classes:</strong> Adapting calculators for residential and hotel
            buildings.
          </li>
          <li>
            <strong>International expansion:</strong> Translating standards for European and US
            contexts.
          </li>
        </ol>

        <p>
          These steps move us toward a single, connected environment for early-stage design — a
          space where feasibility, compliance, and creativity can coexist from day one.
        </p>

        <p>
          Pebbledash is still young, but the intent is clear: to give designers better tools,
          earlier, and to make the process of shaping buildings a little more intelligent.
        </p>
      </article>
    </section>
  );
}
